"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../utils/helpers/class-names"));
var card_style_1 = require("./card.style");
var Card = function (_a) {
    var children = _a.children, _b = _a.shadow, shadow = _b === void 0 ? 'none' : _b, reverse = _a.reverse, _c = _a.color, color = _c === void 0 ? 'inherit' : _c, className = _a.className, rest = tslib_1.__rest(_a, ["children", "shadow", "reverse", "color", "className"]);
    return (react_1["default"].createElement("div", tslib_1.__assign({ className: (0, class_names_1["default"])("flex flex-col rounded-2xl overflow-hidden", card_style_1.SHADOW[shadow], reverse ? card_style_1.REVERSE_COLORS[color] : card_style_1.COLORS[color], className) }, rest), children));
};
exports["default"] = Card;
//# sourceMappingURL=card.js.map